import { getSelectedCountryCode } from "@utils/countryUtils";
import { getCurrentUserId } from "@utils/userUtils";
import {
  streamFacilityComplianceParallel,
  streamFacilityCompliancePenaltiesOnly,
  type FacilityCompliancePayload,
} from "./facilityCompliance";

export type PostCheckoutPrewarmInput = {
  facilityId: number;
  facilityName: string;
  city?: string | null;
  state?: string | null;
  facilityTypeSlug?: string | null;
  primaryProfileSlug?: string | null;
  vertical?: string | null;
  orgName?: string | null;
  facilityTypeId?: number | null;
};

export function buildPostCheckoutCompliancePayload(
  input: PostCheckoutPrewarmInput,
): FacilityCompliancePayload {
  const userId = parseInt(getCurrentUserId(), 10) || 0;
  return {
    user_id: userId,
    organization: input.facilityName,
    facility_name: input.facilityName,
    facility_type:
      input.primaryProfileSlug || input.facilityTypeSlug || "",
    country: getSelectedCountryCode(),
    state: input.state ? String(input.state).trim() : "",
    county: "",
    city: input.city ? String(input.city).trim() : "",
    site_url: "",
    documents: "",
    as_of_date: new Date().toISOString().split("T")[0],
    response_language: "English",
    instructions:
      "Search government regulatory sites for compliance requirements, permits, licenses, and medical facility documentation",
    output_format: "JSON",
    org_name: input.orgName || "test",
    facility_id: input.facilityId,
    facility_type_id: input.facilityTypeId ?? undefined,
    vertical: input.vertical ?? undefined,
    primary_profile_slug: input.primaryProfileSlug ?? undefined,
    include_penalties: false,
  };
}

let prewarmSessionFacilityId: number | null = null;

/** Fire-and-forget compliance SSE during checkout navigation (idempotent per facility). */
export function prewarmPostCheckoutCompliance(input: PostCheckoutPrewarmInput): void {
  if (!input.facilityId || !input.facilityName.trim()) {
    return;
  }
  if (prewarmSessionFacilityId === input.facilityId) {
    return;
  }
  prewarmSessionFacilityId = input.facilityId;

  const analysisPayload = buildPostCheckoutCompliancePayload(input);
  const penaltiesPayload = { ...analysisPayload, include_penalties: true };
  const noop = () => {};

  const fireAndForget = (promise: Promise<void> | void) => {
    Promise.resolve(promise).catch(() => {});
  };

  fireAndForget(streamFacilityCompliancePenaltiesOnly(penaltiesPayload, noop));
  fireAndForget(streamFacilityComplianceParallel(analysisPayload, noop));
}

export function clearPostCheckoutCompliancePrewarmForTests(): void {
  prewarmSessionFacilityId = null;
}
